module.exports = __webpack_public_path__ + "img/delete_grid.cffaa78c.png";